// extracted by mini-css-extract-plugin
module.exports = {"appendix_table":"_2mv4rTw"};